import Vue from 'vue'
import VueRouter from 'vue-router'
import { routeGuard } from './guard'

import Home from "../views/Home.vue";

import LojaRepresView from "../views/LojaRepres/LojaRepresView.vue";
import Login from "../views/Login/Login.vue";
import Politica from '../views/PoliticaPrivacidade/PoliticaPrivacidadeView.vue';

// rotas das pages
import transportadorasRouter from "../views/Transportadora/router";
import avaliacaoFornecRouter from "../views/AvaliacaoFornec/router";
import homologacaoFornecRouter from '../views/Homologacao/router';
import clientesRouter from "../views/Clientes/router";
import consultasRouter from "../views/Consultas/router";
// import fornecRouter from '../views/Fornecedores/router';
import pedidosRouter from '../views/Pedidos/router';
import franquiasContratosRouter from '../views/Franquias/router';
import builderRouter from '../views/Builder/router';
import lotesRouter from '../views/Lotes/router';
import coletasRouter from '../views/Coletas/router';
import notasRouter from '../views/Notas/router';
import eventsdataRouter from '../views/ListEventsData/router';
import rastreioRouter from '../views/Rastreio/router';
import caixasaidaRouter from '../views/CaixaSaida/router';
import financeiroRouter from '../views/Financeiro/router';
import produtosRouter from '../views/Produtos/router';
import integracoesAkrRouter from '../views/Integracoes/AKR/router';
import despesasRouter from '../views/Despesas/router';
import linkbase64Router from '../views/Tools/router';

// rotas para testes
import testesRouter from './testes';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: "/politica",
    name: "Politica",
    component: Politica,
  },
  {
    path: '/lojarepres',
    name: 'LojaRepresentante',
    beforeEnter: routeGuard,
    component: LojaRepresView
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import('../views/About.vue')
  },
  {
    path: '/testes',
    name: 'Testes',
    component: () =>
      import('../Testes.vue')
  },
  {
    path: '/manutencao',
    name: 'Manutencao',
    component: () =>
      import('../views/Manutencao.vue')
  },
  {
    path: '/atualizacao',
    name: 'Atualizacao',
    component: () =>
      import('../views/Atualizacao.vue')
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () =>
      import('../views/Unauthorized.vue')
  },
  {
    path: '/speedtest',
    name: 'Speedtest',
    component: () =>
      import('../views/Speedtest.vue')
  },
  {
    path: '/agradecimentos',
    name: 'Agradecimentos',
    component: () =>
      import('../components/Agradecimentos.vue')
  },
  
  ...transportadorasRouter,
  ...avaliacaoFornecRouter,
  ...homologacaoFornecRouter,
  ...clientesRouter,
  // ...fornecRouter,
  ...pedidosRouter,
  ...franquiasContratosRouter,
  ...builderRouter,
  ...consultasRouter,
  ...lotesRouter,
  ...coletasRouter,
  ...testesRouter,
  ...notasRouter,
  ...eventsdataRouter,
  ...rastreioRouter,
  ...caixasaidaRouter,
  ...financeiroRouter,
  ...produtosRouter,
  ...integracoesAkrRouter,
  ...despesasRouter,
  ...linkbase64Router,
  {
    path: '*',
    name: 'Page404',
    component: () => 
      import('../views/Page404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth)

  if (requiresAuth == true) {
    if (!Vue.$cookies.get('token') || Vue.$cookies.get('token') == "") {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
